import { render, staticRenderFns } from "./CarouselSlide.vue?vue&type=template&id=5b1a87e2&"
import script from "./CarouselSlide.vue?vue&type=script&lang=js&"
export * from "./CarouselSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports